export const getAppStoreUrl = (): string => {
  const userAgent = navigator.userAgent || navigator.vendor

  // Check for iOS devices
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return "https://apps.apple.com/us/app/hived-team/id6479320628"
  }

  // Check for Android devices
  if (/android/i.test(userAgent)) {
    return "https://play.google.com/store/apps/details?id=space.hived.team"
  }

  // Default to iOS link for other devices
  return "https://apps.apple.com/us/app/hived-team/id6479320628"
}
